<template>
    <div>
        <el-upload ref="uploadFile" :action="uploadAction" :limit="6" :data="uploadData" :headers="uploadHeader"
            :file-list="fileList" :multiple="true" :show-file-list="true" :on-remove="handleRemove"
            :on-success="handleUploadFileSuccess" :before-remove="beforeRemove"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx">
            <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
    </div>
</template>

<script>
import { objKeySort } from '@/utils/auth'
import { getStorage } from '@/utils/auth'
export default {
    name: 'FromFile',
    components: {},
    props: {
        value: {
            type: Array,
            default: []
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        fileList(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.fileList = value
        }
    },
    data() {
        return {
            uploadAction: process.env.VUE_APP_BASE_API + 'common/uploadFile',
            uploadHeader: { Authorization: getStorage('token') },
            uploadData: {
                sign: objKeySort([])[2]
            },
            fileList: this.value
        }
    },
    methods: {
        handleUploadFileSuccess(res, file) {
            console.log(1111, file)
            console.log(222, res)
            this.fileList.push(res.data)
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
            console.log(file, fileList)
        },
        clearFiles() {
            this.fileList = []
            if (this.$refs.uploadFile) {
                this.$refs['uploadFile'].clearFiles()
            }
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
    }
}
</script>
